import {useEffect} from 'react';

export function useEditorPrefetchQRMobileModules(): void {
  useEffect((): void => {
    void prefetchQRItemModules();
  }, []);

  const prefetchQRItemModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-qr-content-background-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-qr-content-color-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-qr-content-panel');
  };
}
